/* Do not edit these strings. They are generated by ptmessages.js.php */
ptMessages = {
    "partnerdownloadbookmark": "\u00bfYa cre\u00f3 un marcador para esta p\u00e1gina? Pulse <CTRL> + D para agregar un marcador.",
    "applyunload": "Usted a\u00fan no ha enviado la solicitud completa para su prueba gratuita.",
    "equaltocaseinsensitivemsg": "Introduzca de nuevo el mismo valor.",
    "distanceunitmiles": "Millas",
    "distanceunitkilometers": "Kil\u00f3metros",
    "distanceperyearlabel": " por a\u00f1o",
    "hours": "horas",
    "priceinterval3": "(pago cada 3 meses)",
    "priceinterval12": "(pago anual)",
    "priceinterval36": "(pago cada 3 meses)",
    "enterprise": "Empresa",
    "enthintbuymore": "A partir de 2 licencias para representantes:",
    "enthintusermgmt": "Administraci\u00f3n central de usuarios",
    "enthintrights": "Administraci\u00f3n de permisos",
    "enthintorgsettings": "Ajustes para toda la empresa",
    "enthintapi": "Importaci\u00f3n y exportaci\u00f3n de datos mediante API",
    "enthintodata": "An\u00e1lisis de datos mediante Excel y OData",
    "enthintadmins": "Cuentas de administrador gratuitas",
    "shopbuysub": "por {invoiceamountinclvat} cada {billinginterval} meses hasta que se cancele",
    "shopvatsub": "El importe incluye {vatamount} de IVA ({vatrate}%).<br\/>Este importe se detalla por separado en la factura.",
    "shopprice": "Precio",
    "shoppriceincurrency": "Precio en {currency}",
    "shopcurrencysub": "Todos los precios en {currency}",
    "shopvatnotapplicable": "{vatamount} de IVA ({vatrate}%) se incluir\u00e1n en la factura.",
    "shopordersumvatsub": "{totalincl} incl. {vatrate}% IVA",
    "shopmindatevalidate": "La fecha debe igualar o superar {2}.",
    "enthintbuyevenmore": "A partir de 10 licencias para representantes:",
    "enthintusergroups": "Grupos de usuarios",
    "etrackerstatus": "Estado:",
    "etrackeractive": "etracker est\u00e1 activado.",
    "etrackerinactive": "etracker est\u00e1 desactivado.",
    "etrackeroptin": "Activar etracker",
    "etrackeroptout": "Desactivar etracker",
    "brPhoneErrorMessage": "Introduzca un n\u00famero de tel\u00e9fono v\u00e1lido (10 o m\u00e1s d\u00edgitos)",
    "integererror": "Introduzca s\u00f3lo n\u00fameros enteros",
    "initvatnrlabel": "CIF",
    "ptSimpleForm_date": "Seleccione s\u00f3lo d\u00edas laborables",
    "ptSimpleForm_mindate": "La fecha debe ser a partir de {calculatedMinDate}.",
    "ptSimpleForm_noWeekends": "Seleccione s\u00f3lo d\u00edas laborables",
    "ibanErrorMessage": "Introduzca un IBAN v\u00e1lido"
};
